/**
 * A simple wrapper around IntersectionObserver
 */
export abstract class Observer {
  constructor(protected readonly observer: IntersectionObserver) {}

  public abstract observe<T extends Element>(el: T): void;

  public abstract unobserve<T extends Element>(el: T): void;
}

export class ObserverImpl extends Observer {
  public observe<T extends Element>(el: T): void {
    this.observer.observe(el);
  }

  public unobserve<T extends Element>(el: T): void {
    this.observer.unobserve(el);
  }
}
